/**
 * MarqueeBar — infinite horizontal scrolling bar.
 * Duplicate children inside for seamless loop.
 */
export const MarqueeBar = ({ children, className = "", speed = "slow", direction = "left" }) => {
  const animClass = speed === "slow" ? "animate-marquee-slow" : "animate-marquee";
  const dirStyle = direction === "right" ? { animationDirection: "reverse" } : {};

  return (
    <div className={`overflow-hidden ${className}`} data-testid="marquee-bar">
      <div className={`flex w-max ${animClass}`} style={dirStyle}>
        <div className="flex shrink-0">{children}</div>
        <div className="flex shrink-0" aria-hidden="true">{children}</div>
      </div>
    </div>
  );
};
